import { render, staticRenderFns } from "./ClientAdmins.vue?vue&type=template&id=15518812&scoped=true&"
import script from "./ClientAdmins.vue?vue&type=script&lang=ts&setup=true&"
export * from "./ClientAdmins.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./ClientAdmins.vue?vue&type=style&index=0&id=15518812&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15518812",
  null
  
)

export default component.exports